export default __webpack_public_path__ + "static/media/odpowiedzi-uzytkownika.cd9559a4.png";